module.exports = __webpack_public_path__ + "img/11.d4ff9078.png";